import { Add, Delete } from '@mui/icons-material'
import { Button, FormControl, FormHelperText, IconButton, TextField } from '@mui/material'
import React, { useState } from 'react'

export interface ValidDomainInputProps {
  id: number
  value: string
  last: boolean
  onChange: (e: any) => void
  onRemove: () => void
  onAdd: () => void
}

const ValidDomainInput = (props: ValidDomainInputProps) => (
  <FormControl fullWidth={false} required={true} sx={{ marginTop: 2, display: 'block' }}>
    <TextField fullWidth id={`ip-text-valid-domain-${props.id}`} label={props.id === 0 ? `Valid domain` : ``} variant="outlined"
      size="small" name={`valid-domain-${props.id}`} type="email" autoComplete="email"
      value={props.value} onChange={(e: any) => props.onChange(e)}
      InputProps={{ endAdornment: <IconButton color="error" disabled={props.id === 0} onClick={props.onRemove} edge="end"><Delete /></IconButton> }}
    />
    {props.last && <IconButton color="success" onClick={props.onAdd} sx={{ marginBottom: 2, marginLeft: 1 }}><Add /></IconButton>}
  </FormControl>
)

export default ValidDomainInput